import zbRecords from './records.vue'

export default zbRecords
